import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux';
import { getQueryParam, showAccessDeniedAlert } from '../../managers/common/CommonUtil';
import RouteManager, { PAGE_ROUTES } from '../../managers/RouteManager';
import { TableManger, TABLES } from '../../managers/TableManger';
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from '../../utility/Utility';
import { parseColumnConfig, PayStubColumnConfig } from '../configs/config';
import {
    DKButton,
    DKLabel
} from "deskera-ui-library";
import Table from '../../services/table';
import DataGridHolderPayroll from '../common/DataGridHolderPayroll';
import AttachmentService from '../../services/AttachmentService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import PayslipDesign from '../PayslipDesign/PayslipDesign';
import DocumentService from '../../services/DocumentService';
import ApiConstants from "../../constants/ApiConstants";
import MaskInputUtil from '../../SharedComponents/MaskInput/MaskInputUtil';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';

var intervalData;
const PayStubList = (props) => {
    const initialState = {
        columnData: [],
        rowData: [],
        originalData: {},
        filter: {}
    };

    var refreshCount = 0;
    
    const gridContainer = useRef()
    const isAdmin = TenantService.get(TENANT.IS_ADMIN);
    const isOwner = TenantService.get(TENANT.IS_OWNER);
    const [selectedUserId, setSelectedUserId] = useState(props.id || getQueryParam(props.location, "id"));
    const [payStubData, setPayStubData] = useState({})
    const [payStubList, setPayStubList] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [showList, setFiltersList] = useState(true);
    const [gridWidth, setGridWidth] = useState(950);
    const [payslipPayload, setPayslipPayload] = useState(null);
    const [refresh, setRefresh] = useState(0);
    const [documentUpdateCount, setDocuemntUpdateCount] = useState(0)
    const [isContractor, setIsContractor] = useState(getQueryParam(props.location, "isContractor"));
    const [showPaystubs, setShowPaystubs] = useState(false);

    const [reload, setReload] = useState(false);
    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable = (( !props.id || props.id == TenantService.get(TENANT.USER_ID)) && !isAdmin) ? MaskInputUtil.subscripeToMaskUnmaskObservable((mask) => {
        setMask(mask);
        setReload(!reload);
    }):null;

    useEffect(() => {
        if (Utility.isEmpty(selectedUserId)) {
            RouteManager.setPresenter({ props });
            const tenantData = TenantService.getData();
            setSelectedUserId(tenantData['USER_ID']);
        }
        
        setGridWidth(gridContainer?.current?.clientWidth || 1000)
        window.addEventListener('resize', handleResize)

        setTimeout(() => {
            setShowPaystubs(true);
        }, 100);

        return () => {
            MaskInputUtil.unsubscribe(maskUnmaskObservable);
        }
    }, []);

    useEffect(() => {
        if (selectedUserId) {
            const param = {
                "limit": props.recent ? 5 : 10,
                "currentPage": 1,
                "sortField": "createdAt",
                "sortOrder": "desc"
            }
            getPayStubData(param);
        }
    }, [selectedUserId]);

    useEffect(() => {
        if (props.mask !== null && props.mask !== undefined) {
            setMask(props.mask);
            setReload(!reload);
        }
    }, [props.mask]);

    const hasSalaryAccess = useMemo(() => {
        return isAdmin
            || isOwner
            || selectedUserId == TenantService.get(TENANT.USER_ID)
            || PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT]);
    }, [isAdmin, isOwner, selectedUserId])

    const handleResize=()=>{
        setTimeout(()=>{
            setGridWidth(gridContainer?.current?.clientWidth || 1000)  
        },100)
    }
    const getCookieValue=()=>{
        let cookieLists = document.cookie.split(";");
        let isCookieContain = false;
        cookieLists.forEach(cookies=>{
            if(cookies.includes("documentUpdateCount")) {
                isCookieContain = true;
            }
        })
        return isCookieContain
    }
    const listenCookieChange = (callback, interval = 1000) => {
        let lastCookie = document.cookie.split("documentUpdateCount=").pop().split(';')[0];
        intervalData = setInterval(() => {
            let cookie = document.cookie.split("documentUpdateCount=").pop().split(';')[0];
            if (cookie !== lastCookie && getCookieValue()) {
                try {
                    callback({ oldValue: lastCookie, newValue: cookie });
                } finally {
                    lastCookie = cookie;
                    setDocuemntUpdateCount(cookie)
                }
            }
        }, interval);
        setDocuemntUpdateCount(lastCookie)
    }

    useEffect(() => {
        if (!Utility.isEmpty(payStubData)) {
            const { paystubs, filterResponse } = payStubData;
            const rowData = PayStubColumnConfig(paystubs, mask);
            let viewConfig 
            if(isContractor === "true" || props?.isContractor) {
                viewConfig = {
                    isContractor: true
                }
                if(props.payStubData) {
                    props.payStubData(payStubData)
                }
            }
            
            let payScheduleColumn = parseColumnConfig(deepClone(TableManger.getTableVisibleColumns(TABLES.PAYSTUB_LIST)), TABLES.PAYSTUB_LIST, viewConfig)
            payScheduleColumn = payScheduleColumn.filter(
              (column) => !column.hidden
            );

            const passingData = {
                columnData: payScheduleColumn,
                rowData,
                filter: [],
                originalData: paystubs
            };
            const isFilterListEnabled = paystubs && paystubs.length > 0 ? true : false;
            const timeout = showDelayedLoader();

            
            setTotalPageCount( !props.recent ? filterResponse ? filterResponse.totalPages : 0 : 1);
            setCurrentPage(filterResponse ? filterResponse.currentPage : 1);
            setTotalCount(!props.recent ? filterResponse ? filterResponse.totalCount : 0 : 5)
            setFiltersList(isFilterListEnabled)
            setTimeout(()=>{
                setPayStubList(passingData);
            },50)
            removeDelayedLoader(timeout);
        }
    }, [payStubData, reload])

    const getPayStubData = (param) => {
        const timeout = showDelayedLoader();
        Table.getPayStub(selectedUserId, param).then(
            (response) => {
                setPayStubData(response)
                removeDelayedLoader(timeout);
            },
            (error) => {
                console.log(error)
            }
        )
    }

    const getFilename = (url) => {
        return url.substring(url.indexOf("_") + 1, url.length);
    }

    const onDesignDocument = (paystub) => {
        if (!PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)) {
            showAccessDeniedAlert();
        } else {
            const payload = {
                employeeId: selectedUserId,
                paystubId: paystub.rowData.id
            }
    
            DocumentService.designDocument(payload).then(
                (response) => {
                    if (response && response.code) {
                        const url = ApiConstants.PRODUCT_URL_DOCUMENT_BUILDER + response.code;
                        window.open(url, "_blank");
                    }
                }, (error) => {
                    console.log(error)
                }
            );
        }
    }

    const downloadPayslip = (paystub) => {
        if (isAdmin && !PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT])) {
            showAccessDeniedAlert();
        } else {
            listenCookieChange(({ oldValue, newValue }) => {
                refreshCount = refreshCount + 1
                setRefresh(refreshCount)
            }, 1000);
    
            const tenantData = TenantService.getData();
            const payload = {
                "event": "PRINT",
                "documentType": "PAYSLIP",
                "employeeId": selectedUserId,
                "tenantId": tenantData.CONFIG.tenantId,
                "paystubId": paystub.rowData.id
            }
    
            setPayslipPayload(payload);
        }
    }

    const onBackClick = () => {
        if (isContractor === "true") {
            RouteManager.navigateToPage(
                PAGE_ROUTES.CONTRACTOR_VIEW,
                `id=${selectedUserId}`
            );
        } else {
            RouteManager.navigateToPage(
                PAGE_ROUTES.EMPLOYEE_VIEW,
                `id=${selectedUserId}`
            );
        }
    }

    const onClose = () =>{
        if(intervalData) {
            clearInterval(intervalData);
        }
        setRefresh(0)
        setPayslipPayload(null)
    }

    return (
        <>
        {payslipPayload && <PayslipDesign payload={payslipPayload} documentUpdateCountRefresh={refresh}   {...props} onClose={()=>{
            onClose()
        }}/>}
        <div className="row">
            <div className="column parent-width parent-height mb-s position-relative flex-1" ref={gridContainer}>
                <div className="row" 
                // style={{ marginBottom: `${props.recent ? "-16px" : "-25px"}` }}
                >
                    <DKLabel text={"Paystubs"} className="fw-m fs-l mr-m" />
                </div>
                {showPaystubs && <DataGridHolderPayroll
                    tableName={TABLES.PAYSTUB_LIST}
                    allowRowEdit={false}
                    allowColumnEdit={false}
                    allowColumnDelete={true}
                    onDownloadAttachment={(data) => {
                        downloadPayslip(data)
                    }}
                    onDesignDocument={(data)=>{
                        onDesignDocument(data)
                    }}
                    allowRowAdd={true}
                    allowColumnAdd={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    gridWidth={gridWidth}
                    allowFilter={false}
                    addButtonConfig={[{}]}
                    allowDataExport={true}
                    gridData={payStubList}
                    onPaginationClick={(requestedPageNumber) => {
                        const config = {
                            "limit": props.recent ? 5 : 10,
                            "currentPage": requestedPageNumber,
                            "sortField": "createdAt",
                            "sortOrder": "desc"
                        };
                        getPayStubData(config);
                    }}
                    filter={payStubList.filter}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    isActionEnabled={hasSalaryAccess}
                    isMenuVisible={false}
                    contextMenu={false}
                    isActionColumnFirst={true}
                    module={MODULE.PAYSTUB}
                />}
                {(isAdmin && !props.recent)&& <DKButton
                    title="Back"
                    className="fw-m bg-app text-white"
                    onClick={() => {
                        onBackClick()
                    }}
                />}
            </div>
        </div>
        </>
    )
}

export default PayStubList
